module.exports = __webpack_public_path__ + "img/logo_final.695fe008.svg";